import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-data-vencimento',
  templateUrl: './text-data-vencimento.component.html',
  styleUrls: ['./text-data-vencimento.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextDataVencimentoComponent implements OnInit {

  now: string = new Date().toISOString().split('T')[0];
  
  constructor() { }
  
  ngOnInit() { }
  
}
